
import { writable, derived } from 'svelte/store';

// const [, _hash] = window.location.pathname.match(/^\/([^/]+)/);
export const hash = writable('');

export const lang = writable('');
export const newsAndEvent = writable([]);
export const offers = writable([]);
export const openingHours = writable();
export const stores = writable([]);
export const banners = writable([]);
export const mediaPlaylist = writable();

export const resources = writable();

export const searchBarInput = writable();
export const searchTerm = writable('');
export const searchMapFeatures = writable(false);
export const searchCaret = writable({ start: 0, end: 0 });

// export const isMapSearch

export const screensaverOn = writable(false);
export const playerOn = writable(false);

export const selected3rdParty = writable();

const _lastViews = writable([]);
const _viewActive = writable();
const _viewActiveSet = _viewActive.set;

export const viewActive = Object.assign(_viewActive, {

  set (value = 'start') {

    const [, view] = value.match(/^#?(.+)/) || [0,value];
    _viewActiveSet(view);

    let prevView;
    _lastViews.update(([prev]) => {
      prevView = prev;
      return [view, prev];
    });

    return [view, prevView];
  }
});

export const viewPrev = derived(_lastViews, $_lastViews => {
  const [, prev] = $_lastViews;
  return prev;
});

/* Session timing */
export const userLastActive = writable(new Date(0));

export const idleTime = derived(userLastActive, ($userLastActive, set) => {

  const interval = setInterval(() => {
    const now = Date.now();
    const lastActive = $userLastActive.getTime();
    set(now - lastActive);
  }, 1000);

  return () => clearInterval(interval);
});

export function setupTimeouts (settings) {

  const player_timeout_ms = parseInt(settings.timeouts.player) * 1000;
  const session_timeout_ms = parseInt(settings.timeouts.player) * 1000;

  const playerTimeout = derived([idleTime], $idleTime => $idleTime >= player_timeout_ms);
  const sessionTimeout = derived([idleTime], $idleTime => $idleTime >= session_timeout_ms);

  return {
    playerTimeout,
    sessionTimeout
  };
}
